var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavourites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3299 3.5401C20.4943 1.82521 18.0872 0.422111 15.2873 1.23902C13.9493 1.62549 12.782 2.45428 11.976 3.58999C11.1699 2.45428 10.0026 1.62549 8.66465 1.23902C5.85846 0.434583 3.45761 1.82521 2.62199 3.5401C1.44963 5.94095 1.93604 8.64113 4.06874 11.5658C5.73998 13.8544 8.12836 16.1742 11.5956 18.8681C11.7051 18.9536 11.8401 19 11.9791 19C12.118 19 12.253 18.9536 12.3626 18.8681C15.8236 16.1804 18.2182 13.8793 19.8894 11.5658C22.0159 8.64113 22.5023 5.94095 21.3299 3.5401V3.5401Z",
    stroke: "#000000",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourites);
export default __webpack_public_path__ + "static/media/favourites.e549e25f265c44d6028093352e194c27.svg";
export { ForwardRef as ReactComponent };